import { wrapHttpClient } from '../helper/HttpHelper';
import { httpClient } from '../network/httpclient/HttpClientFactory';
import authHeader from './Header';

const getTemplateList = () => httpClient.get(`/approval-template`, { headers: authHeader() }).then(res => res.data);

const getLine = masterId =>
    httpClient.get(`/approval-line/${masterId}`, { headers: authHeader() }).then(res => res.data);

const sign = param => httpClient.post('/approval-sign', param, { headers: authHeader() }).then(res => res.data);

const cancelSign = masterId =>
    httpClient.put(`/approval-cancel/${masterId}`, {}, { headers: authHeader() }).then(res => res.data);

const postLine = param => httpClient.post(`/approval-line`, param, { headers: authHeader() }).then(res => res.data);

export default {
    getTemplateList: wrapHttpClient(getTemplateList),
    getLine: wrapHttpClient(getLine),
    sign: wrapHttpClient(sign),
    cancelSign: wrapHttpClient(cancelSign),
    postLine: wrapHttpClient(postLine)
};
